import { Maybe } from '../../../__generated__/globalTypes'

import minimalOrderFragmentRawString from '../MinimalOrderFragment.graphql'

export const minimalOrderFragmentString = minimalOrderFragmentRawString

export type MinimalOrderFragment = {
  id: string
  lines: {
    card: Maybe<{
      frontPreviewUrl: string
    }>
    giftVariation: Maybe<{
      imageUrls: string[]
    }>
  }[]
}

export const isMinimalOrderFragment = (
  fragment: any,
): fragment is MinimalOrderFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  Array.isArray(fragment.lines) &&
  fragment.lines
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum &&
        next &&
        (next.card === null ||
          (next.card && typeof next.card.frontPreviewUrl === 'string')) &&
        (next.giftVariation === null ||
          (next.giftVariation &&
            Array.isArray(next.giftVariation.imageUrls) &&
            next.giftVariation.imageUrls
              .slice(0, 5)
              .reduce(
                (accum: any, next: any) => accum && typeof next === 'string',
                true,
              ))),
      true,
    )
